import {Component, Inject, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {InstallationQuote} from '../../data/Installation-quote';
import {ProjectFile} from '../../../../../app-misc/src/app/modules/project-misc/data/project/project-file';
import {MatDialog} from '@angular/material/dialog';
import {HttpEventType, HttpProgressEvent, HttpResponse} from '@angular/common/http';
import {QuotesService} from '../../data/quotes.service';
import {MiscSnackBarService} from '../../../../../core/src/lib/misc/view/snackbar/misc-snackbar.service';
import {FileUpload} from 'primeng/fileupload';
import {API_URL} from '../../../../../core/src/lib/core/utils/tokens';
import {
  PdfPreviewDialogComponent
} from 'projects/app-misc/src/app/modules/project-misc/view/pdf-preview-dialog/pdf-preview-dialog.component';
import {
  ImageGalleryCarouselComponent
} from 'projects/app-misc/src/app/modules/project-misc/view/image-gallery-carousel/image-gallery-carousel.component';
import moment from 'moment';
import {FileService} from 'projects/core/src/lib/misc/data/file/file.service';
import {FileOpenerService} from 'projects/app-misc/src/app/modules/project-misc/utils/fileOpener.service';

@Component({
  selector: 'app-quote-files',
  templateUrl: './quote-files.component.html',
  styleUrls: ['./quote-files.component.scss']
})
export class QuoteFilesComponent implements OnInit, OnDestroy {

  @Input()
  quote: InstallationQuote

  @Input()
  quoteCode: string;

  quoteFiles: ProjectFile[] = []

  progressBar: number;

  @ViewChild('filesForm', {static: false})
  filesForm: FileUpload;

  filePasteListener = null;

  filesLoading = true;

  constructor(
    protected fileService: FileService,
    protected fileOpenerService: FileOpenerService,
    @Inject(API_URL) protected apiUrl: string,
    protected dialog: MatDialog,
    protected quoteService: QuotesService,
    protected miscSnackBarService: MiscSnackBarService
  ) {
  }

  ngOnInit(): void {
    this.filePasteListener = (event: ClipboardEvent) => {
      this.onFilePaste(event)
    }

    document.addEventListener('paste', this.filePasteListener);

    this.getFiles()
  }

  getFiles() {
    let service = this.quoteService.getQuoteFilesByCode(this.quoteCode)

    if (!this.quoteCode) {
      service = this.quoteService.getQuoteFiles(this.quote.id)
    }

    service.subscribe(files => {
      this.quoteFiles = files;
      this.filesLoading = false;
    }, error => {
      this.filesLoading = false;

      this.miscSnackBarService.openErrorSnackBar(error.message)
    })
  }

  onProgress(event) {
    // this.progressBar = event.progress;
    //
    // if (this.progressBar === 100) {
    // }
  }

  uploadFile(files, filesForm?) {

    const fileArray = [];

    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < files.length; i++) {
      fileArray.push(files[i])
    }

    let service = this.quoteService.uploadQuoteFilesByCode(fileArray, this.quoteCode)

    if (!this.quoteCode) {
      service = this.quoteService.uploadQuoteFiles(fileArray, this.quote.id)
    }

    service.subscribe(httpEvent => {
      if (httpEvent.type === HttpEventType.UploadProgress) {
        const progressEvent = httpEvent as HttpProgressEvent
        this.progressBar = Math.ceil(progressEvent.loaded / progressEvent.total * 100 / 3) * 3
      } else if (httpEvent.type === HttpEventType.Response) {
        const projectFiles = (httpEvent as HttpResponse<ProjectFile[]>).body;
        this.quoteFiles = this.quoteFiles.concat(projectFiles)
        this.progressBar = 0
      }

      filesForm?.clear();
    }, error => {
      this.progressBar = 0
      this.miscSnackBarService.openErrorSnackBar(error.message)
    })
  }

  chooseFile() {
    this.filesForm.choose()
  }

  openFile(file: ProjectFile) {
    if (file.ext === 'pdf') {
      this.openPdf(file);
    } else if (file.ext === 'jpg' || file.ext === 'jpeg' || file.ext === 'png' || file.ext === 'webp') {
      const imgFileLinks = [];

      this.quoteFiles.forEach(file => {
        if (file.ext === 'jpg' || file.ext === 'jpeg' || file.ext === 'png' || file.ext === 'webp') {
          imgFileLinks.push(this.getQuoteFileLink(file))
        }
      });


      this.openGallery(file, imgFileLinks);
    } else {
      this.downloadFile(file)
    }
  }

  openPdf(miscFile: ProjectFile): void {
    this.dialog.open(PdfPreviewDialogComponent, {
      data: {
        dialogHeader: miscFile.name,
        link: this.getQuoteFileLink(miscFile),
        showSendButton: false
      },
      panelClass: 'pdf-preview-dialog'
    });
  }

  getQuoteFileLink(miscFile: ProjectFile) {
    let link = this.fileService.getDownLoadFileLinkForQuote(this.quoteCode, miscFile.id)

    if (!this.quoteCode) {
      link = this.fileService.getDownLoadFileLink(miscFile.id)
    }

    return link
  }

  downloadFile(miscFile: ProjectFile) {
    window.open(this.apiUrl + this.getQuoteFileLink(miscFile), '_blank');
  }

  openGallery(miscFile: ProjectFile, imgFileLinks: string[]): void {
    const cpDialogRef = this.dialog.open(ImageGalleryCarouselComponent, {
      data: {
        dialogHeader: 'Installation Quote Files',
        clickedImageId: miscFile.id,
        images: imgFileLinks,
        showSourceButton: false
      },
      panelClass: 'image-carousel-dialog'
    });

    cpDialogRef.afterClosed().subscribe(result => {
    })
  }

  onFilePaste(event: ClipboardEvent) {
    const items = (event.clipboardData).items;
    // tslint:disable-next-line: forin
    for (const index in items) {
      const item = items[index];
      if (item.kind === 'file') {
        const file = item.getAsFile();

        // let timeStamp = moment().format('L LT')
        // let newFile = new File([file], `Screenshot ${timeStamp}.png`, { type: file.type })

        this.uploadFile([file])
      }
    }
  }

  ngOnDestroy() {
    document.removeEventListener('paste', this.filePasteListener)
  }
}
